import React, { Component, ReactNode } from 'react';
import { map } from 'lodash';
import cIf from 'classnames';

export type UnorderedListProps = {
    horizontal?: boolean,
    children: ReactNode[]
};

export class UnorderedList extends Component<UnorderedListProps> {
    static readonly defaultProps = {
        horizontal: false
    };

    render() {
        let items = map(this.props.children, (item, i) => <li key={i}>{item}</li>);
        
        return (
            <ul className={cIf({ "unorderedlist": true, "horizontal": this.props.horizontal })}>
                {items}
            </ul>
        );
    }
}
